// extracted by mini-css-extract-plugin
export var attribution = "_9g-4";
export var authorName = "_9g-5";
export var quote = "_9g-3";
export var testimonial = "_9g-2";
export var trustedBy = "_9g-0";
export var trustedByLabel = "_9g-1";